import { render } from "./PrefectureTab.vue?vue&type=template&id=2ccbc8b5"
import script from "./PrefectureTab.vue?vue&type=script&lang=js"
export * from "./PrefectureTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__